import { useSelector, useDispatch } from 'react-redux';
import FJMobileCreationView from './FJMobileCreationView';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useCallback } from 'react';
import PropTypes from 'prop-types';

const FJMobileCreationViewContainer = props => {
    const { style, forbiddenPreview } = props;
    const dispatch = useDispatch();
    const creationList = useSelector(state => state.common.creationList);
    const previewImage = useCallback(
        data => {
            if (forbiddenPreview) {
                return;
            }
            dispatch(FJActionModal.showPreviewModalDataAction({ data }));
        },
        [forbiddenPreview, dispatch],
    );
    const reGenerate = useCallback(
        id => {
            dispatch(FJActionCommon.reGenerateAction(id));
        },
        [dispatch],
    );
    return (
        <FJMobileCreationView
            creationList={creationList}
            previewImage={previewImage}
            reGenerate={reGenerate}
            style={style}
        />
    );
};

FJMobileCreationViewContainer.propTypes = {
    style: PropTypes.object,
    forbiddenPreview: PropTypes.bool,
};

export default FJMobileCreationViewContainer;
